/**
 * The coupon code a store tile shows under its CTA (BF-5119).
 *
 * Only while the campaign is running: from its start date until its end date. Merchant lists can
 * carry a campaign that has not started or has already ended, and the API only blanks the code
 * before the "show status from" date, so the tile checks the dates itself. A missing date is open.
 */
export interface ITileCouponCampaign {
  couponCode?: string;
  startDate?: string;
  endDate?: string;
}

const parse = (value?: string): number | undefined => (value ? Date.parse(value) : undefined);

export const getActiveTileCoupon = (campaign?: ITileCouponCampaign, now: Date = new Date()): string | undefined => {
  const code = campaign?.couponCode?.trim();
  if (!code) {
    return undefined;
  }

  const start = parse(campaign?.startDate);
  const end = parse(campaign?.endDate);
  if ((start !== undefined && Number.isNaN(start)) || (end !== undefined && Number.isNaN(end))) {
    return undefined;
  }

  const time = now.getTime();
  if (start !== undefined && time < start) {
    return undefined;
  }
  if (end !== undefined && time >= end) {
    return undefined;
  }

  return code;
};
